import React, { useState, useRef, useEffect } from 'react';
import { FaSearch, FaPhone, FaEnvelope, FaBars, FaTimes, FaUser, FaChevronDown } from 'react-icons/fa';
import './nav.css';
import { Link } from 'react-router-dom';

import { RiFile2Fill } from "react-icons/ri"; // Remix Icons




function Nav() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);




  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (!isMenuOpen) {
      setIsDropdownOpen(false);
    }
  };

  // FIXED: Add event parameter and stop propagation
  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation(); // This prevents the event from bubbling up
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      {/* Top Bar */}
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <div className="contact-info">
              <div className="contact-item">
  <a href="tel:+94777324632" className="contact-link">
    <FaPhone className="contact-icon" />
    <span> &nbsp; +94 77 732 4632</span>  &nbsp; 
  </a>
    <a href="tel:+94719566805" className="contact-link">
    <FaPhone className="contact-icon" />
   <span> &nbsp; +94 71 956 6805</span>
  </a>
</div>

<div className="contact-item">
  <a href="mailto:info@retionzcabs.lk" className="contact-link">
    <FaEnvelope className="contact-icon" />
    <span> &nbsp; info@innovativeprefab.lk</span>
  </a>
</div>

            </div>

          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="navbar">
        <div className="container">
          <div className="nav-content">
            {/* Logo */}
            <div className="logo">
              <h2 className="logo-text">Innovative </h2>
              <span className="logo-tagline">Pre Fab Technology</span>
            </div>

            {/* Navigation Links */}
            <div className={`nav-links ${isMenuOpen ? 'nav-links-active' : ''}`}>

              <a href="/" className="nav-link" onClick={closeMenu}>
                Home
              </a>
              
              {/* Services Dropdown - FIXED VERSION */}
              <div className="dropdown" ref={dropdownRef}>
                <button 
                  className="nav-link dropdown-btn" 
                  onClick={toggleDropdown}
                  type="button"
                >
                  Our Services
                  <FaChevronDown className={`dropdown-icon ${isDropdownOpen ? 'rotate' : ''}`} />
                </button>
                <div className={`dropdown-menu ${isDropdownOpen ? 'dropdown-active' : ''}`}>
                  
                  <a href="/Pre fab warehouse building" className="dropdown-link" onClick={closeMenu}>
                    Pre-fabrication Solutions 
                  </a>

                  <a href="/aluminum-window" className="dropdown-link" onClick={closeMenu}>
                    Aluminium Windows 
                  </a>
                  <a href="/curtain-walls" className="dropdown-link" onClick={closeMenu}>
                    Curtain Walls 
                  </a>
                  <a href="/partition" className="dropdown-link" onClick={closeMenu}>
                    Partition
                  </a>
                  {/* <a href="/aluminium-pantry" className="dropdown-link" onClick={closeMenu}>
                    Aluminium Pantry Cupboards 
                  </a> */}
                  <a href="/wall-cladding" className="dropdown-link" onClick={closeMenu}>
                    Wall Cladding 
                  </a>

                  <a href="/shower-cubicle" className="dropdown-link" onClick={closeMenu}>
                    Shower Cubicle 
                  </a>

                  <a href="/roof-and-ceiling" className="dropdown-link" onClick={closeMenu}>
                   Polycarbonate Sheet Roofs & Canopies Ceilings 
                  </a>
                  <a href="/glass-door-glass-partition" className="dropdown-link" onClick={closeMenu}>
                    Glass Partition, Glass Doors & Windows 
                  </a>

                <a href="/green-houses" className="dropdown-link" onClick={closeMenu}>
                    Green Houses
                  </a>

                </div>
              </div>
   
             <a href="/ourwork" className="nav-link" onClick={closeMenu}>
                Our Work
              </a>
              <a href="/aboutus" className="nav-link" onClick={closeMenu}>
                About Us
              </a>
              <a href="/contactus" className="nav-link" onClick={closeMenu}>
                Contact Us
              </a>

              
              <Link
                to="/get-a-quote"
                className="nav-link login-btn"
                style={{ textDecoration: 'none' }}
                onClick={closeMenu}
              >
                <RiFile2Fill className="login-icon" />
                Get a Quote
              </Link>


            </div>
 
       

           

            {/* Mobile Menu Button */}
            <button className="mobile-menu-btn" onClick={toggleMenu}>
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>
      </nav>

      {/* Overlay for mobile menu */}
      {isMenuOpen && <div className="overlay" onClick={closeMenu}></div>}
    </>
  );
}

export default Nav;